<div class="app-acknowledge-quality-manual">
  <qima-button-icon
    class="app-acknowledge-quality-manual__close"
    [qimaButtonIconStyle]="qimaButton.buttonIconStyle.TERTIARY"
    [qimaButtonIconName]="qimaIcon.iconName.CLOSE"
    [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
    (qimaButtonIconClick)="onClose()"
  ></qima-button-icon>

  <div class="app-acknowledge-quality-manual__header">
    <h2 class="app-acknowledge-quality-manual__title">
      {{ 'ACKNOWLEDGE_QUALITY_MANUAL.MODAL_TITLE' | translate }}
    </h2>
  </div>

  <div class="app-acknowledge-quality-manual__content">
    <div
      class="app-acknowledge-quality-manual__intro"
      [innerHTML]="
        modalContentKey
          | translate
            : {
                publishDate: publishDate,
                masterAccount: masterAccount,
              }
      "
    ></div>

    <div class="app-acknowledge-quality-manual__download">
      <qima-button
        [qimaButtonWidth]="buttonWidthFull"
        [qimaButtonLabel]="'COMMON.DOWNLOAD_FILE' | translate: { filename: filename }"
        [qimaButtonSize]="buttonSizeLarge"
        [qimaButtonIconName]="qimaIcon.iconName.DOWNLOAD_IMPORT"
        [qimaButtonIconPosition]="qimaButton.buttonIconPosition.LEFT"
        [qimaTooltipHasArrow]="true"
        [qimaTooltipPosition]="qimaTooltip.position.TOP"
        [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
        [qimaTooltipStyle]="qimaTooltip.style.DARK"
        [qimaTooltipText]="filename"
        qimaTooltip
        (qimaButtonClick)="onDownload()"
      ></qima-button>
    </div>

    <div class="app-acknowledge-quality-manual__confirm">
      <qima-input-checkbox
        [(ngModel)]="isAcknowledged"
        (ngModelChange)="onCheckboxChange()"
      >
      </qima-input-checkbox>
      <span [innerHTML]="'ACKNOWLEDGE_QUALITY_MANUAL.CONFIRM' | translate"></span>
    </div>
  </div>

  <div class="app-acknowledge-quality-manual__footer">
    <qima-button
      [qimaButtonLabel]="'COMMON.OK' | translate"
      [qimaButtonSize]="buttonSizeLarge"
      [qimaButtonIsDisabled]="isButtonDisabled"
      (qimaButtonClick)="onAcknowledge()"
    ></qima-button>
  </div>
</div>
